import React, { useCallback, useContext, useState } from "react";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Button, Spinner } from "reactstrap";
import { ProductContext } from "../../store";
import { DownloadData } from "../../services/FetchData";
import {
	CMS_ASSISTANT_SEARCH_REPORT_EXPORT_ENDPOINT,
	mapCmsAssistantExportSortField,
} from "../../constants/cmsAssistantSearchReportExports";
import { triggerXlsxDownload } from "../../utils/triggerXlsxDownload";

const CmsAssistantReportExportButton = ({
	reportKey,
	sortField = null,
	sortOrder = "desc",
	resultsPageOnly = false,
}) => {
	const [exporting, setExporting] = useState(false);
	const { currentWebsiteId, dateRange } = useContext(ProductContext);

	const runExport = useCallback(async () => {
		if (!reportKey) return;
		if (!currentWebsiteId) {
			toast.error("Website ID is missing");
			return;
		}

		const mappedSort = mapCmsAssistantExportSortField(reportKey, sortField);
		const payload = {
			reportKey,
			websiteId: currentWebsiteId,
			startDate: format(dateRange.startDate, "yyyy-MM-dd"),
			endDate: format(dateRange.endDate, "yyyy-MM-dd"),
			sortOrder: sortOrder || "desc",
			resultsPageOnly,
		};
		if (mappedSort) payload.sortField = mappedSort;

		setExporting(true);
		try {
			const data = await DownloadData("ms4", CMS_ASSISTANT_SEARCH_REPORT_EXPORT_ENDPOINT, payload);
			if (data instanceof ArrayBuffer) {
				const defaultName = `enterprise_search_${reportKey}_${payload.startDate}_${payload.endDate}.xlsx`;
				triggerXlsxDownload(data, defaultName);
				toast.success("Export downloaded.");
				return;
			}
			throw new Error(data?.message || "Export failed");
		} catch (error) {
			console.error("CMS Assistant search report export error:", error);
			toast.error(error.message || "Failed to export report.");
		} finally {
			setExporting(false);
		}
	}, [reportKey, currentWebsiteId, dateRange, sortField, sortOrder, resultsPageOnly]);

	return (
		<Button color="primary" size="sm" onClick={runExport} disabled={exporting}>
			{exporting ? <Spinner size="sm" /> : "Export XLSX"}
		</Button>
	);
};

export default CmsAssistantReportExportButton;
